import styled from 'styled-components';

const MainPageContainer = styled.div`
  animation: fadeIn 1.5s;
  display: flex;
  flex: 1;
  flex-direction: column;
  ${({ backgroundColor }) => backgroundColor && `background-color:${backgroundColor}`}
  height: ${({ height }) => height || 'auto'};

  @media screen and (max-width: 767px) {
    min-height: 100%;
  }
`;

export default MainPageContainer;
